import { cn } from '@/components/ui/cn'
import type { CefrLevel } from '@/types/common'

const cefrColors: Record<CefrLevel, string> = {
  A1: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  A2: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200',
  B1: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  B2: 'bg-violet-100 text-violet-800 dark:bg-violet-900 dark:text-violet-200',
  C1: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  C2: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
}

interface CefrBadgeProps {
  level: CefrLevel
  className?: string
}

export function CefrBadge({ level, className }: CefrBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        cefrColors[level],
        className
      )}
    >
      {level}
    </span>
  )
}
